import { useSpring, animated } from 'react-spring';
import './Style/Style.css'

const AnimateMenu = () => {
        const animationProps = useSpring({
          from: { width: 20 }, 
          to: { width : 200 }, 
          config: { duration: 500 }, 
        })
      
        return ( 
        <svg id="evPniDI8p5X1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" shape-rendering="geometricPrecision" text-rendering="geometricPrecision">
            <animated.rect width={animationProps.width} height="37.127206" rx="18.56" ry="18.56" transform="translate(62.659769 79.869142)" fill= "#9623d2" stroke-width="0"/>
            <animated.rect width={animationProps.width} height="37.127206" rx="18.56" ry="18.56" transform="translate(62.659769 130.386488)" fill="#9623d2" stroke-width="0"/>
            <animated.rect width={animationProps.width} height="37.127206" rx="18.56" ry="18.56" transform="translate(62.659769 183.003652)" fill="#9623d2" stroke-width="0"/>
        </svg>    
        );
      };


export default AnimateMenu;